<template>
  <div class="multiple-table">
    <div class="left-wrap">
      <header>
        <slot name="left-header"></slot>
      </header>
      <div class="table-wrap">
        <Table
          ref="selection"
          border
          :columns="tableColumns"
          :data="tableList"
          :loading="tableLoading"
          :max-height="maxHeight"
          @on-select="pickItem"
          @on-select-cancel="cancelItem"
          @on-select-all="pickAll"
          @on-select-all-cancel="cancelAll"
        >
        </Table>
      </div>
      <footer>
        <slot name="left-footer"> </slot>
      </footer>
    </div>
    <div class="right-wrap">
      <h2 style="margin-bottom: 16px">
        {{ rightTitle }}({{ selectList.length }})
      </h2>
      <div v-if="selectList.length > 0" class="select-list-wrap">
        <ul>
          <li v-for="(item, index) in selectList" :key="item.id">
            <span> {{ item.name }}</span>
            <Icon
              class="cursor-pointer"
              size="18"
              type="ios-close-circle"
              @click="handleDelect(item, index)"
            ></Icon>
          </li>
        </ul>
      </div>
      <p v-if="rightText && selectList.length == 0" class="default-text">
        {{ rightText }}
      </p>
    </div>
  </div>
</template>
<script>
import Header from '../layout/Header.vue';
import { deepCopy } from '@/utils/utils.js';
export default {
  components: { Header },
  props: {
    // 表格loading
    tableLoading: {
      type: Boolean,
      default: false
    },
    // 右边title名称
    rightTitle: {
      type: String,
      default: '已选中的数据'
    },
    rightText: {
      type: String,
      default: ''
    },
    maxHeight: {
      type: Number,
      default: 550
    },


    // 已选中的数据
    selectData: {
      type: Array,
      default: () => []
    },
    // 表格数据
    tableData: {
      type: Array,
      default: () => []
    },
    // 表头
    tableColumns: {
      type: Array,
      default: () => []
    }
  },

  data() {
    return {
      selectList: [],
      tableList: []
    };
  },
  watch: {
    selectData: {
      handler(newValue) {
        this.handleInitSelectData(newValue)

      },
      deep: true
    },
    tableData: {
      handler(newValue) {
        this.$nextTick(() => {
          this.handleInitTabelData(newValue)
        })

      },
      deep: true
    }
  },
  methods: {
    handleInitSelectData(data) {
      this.selectList = deepCopy(data)
    },
    handleInitTabelData(data) {
      this.tableList = deepCopy(data).map(item => {
        item._checked = false
        if (this.selectList.findIndex((item_1) => { return item_1.id == item.id }) != -1) {
          item._checked = true
        }
        return item;
      });
    },
    // 删除
    handleDelect(row, index) {
      this.selectList.splice(index, 1)
      this.tableList = this.tableList.map(item => {
        item._checked = false;
        const target = this.selectList.find((item_1) => {
          return item_1.id === item.id;
        });
        if (target) {
          item._checked = true
        }
        return item;
      });
    },
    // 选中单个
    pickItem(selection, row) {
      const key = this.selectList.findIndex((item) => {
        return item.id === row.id;
      });
      if (key != -1) {
        return null;
      }
      this.selectList.push(row);

    },
    // 取消单个
    cancelItem(selection, row) {
      const key = this.selectList.findIndex((item) => {
        return item.id === row.id;
      });
      console.log(key);
      if (key != -1) {
        this.selectList.splice(key, 1)
      }

    },
    // 全部选中
    pickAll(selection) {
      selection.forEach(item => {
        this.pickItem(selection, item)
      })
    },
    // 全部取消
    cancelAll(selection) {
      this.tableList.forEach(item => {
        this.cancelItem([], item)
      })
    },
    getResult() {
      return deepCopy(this.selectList)
    }
  }

}
</script>

<style lang="scss" scoped>
.multiple-table {
  display: flex;
  .left-wrap {
    width: calc(100% - 400px);
    margin-right: 16px;
  }
  .right-wrap {
    width: 400px;

    .select-list-wrap {
      max-height: 550px;
      overflow-y: scroll;
      padding: 10px 10px 0;
      border-radius: 4px;
      background-color: #eee;
      li {
        display: flex;
        justify-content: space-between;
        margin-bottom: 6px;
        font-size: 14px;
      }
    }
    .default-text {
      text-align: center;
      padding: 16px 0;
      background-color: #eee;
    }
  }
}
</style>
